// 在这里注册你的业务页面
// ################################## 开始使用自己的菜单-- 指向视图   ##########################################
export default [
	// 客服列表
	{
		path: '/kf/adminu',
		name: 'KfAdminUList',
		component: () => import(/* webpackChunkName: "KfAdminUList", */ '@/views/admin/Adminu'),
		meta: {}
	},
	// 域名列表
	{
		path: '/domian/list',
		name: 'DomainList',
		component: () => import(/* webpackChunkName: "DomainList", */ '@/views/config/domain'),
		meta: {}
	},
	{
		path: '/ip/list',
		name: 'IPList',
		component: () => import(/* webpackChunkName: "IpList", */ '@/views/ips/index'),
		meta: {}
	},
	{
		path: '/blackip/list',
		name: 'BlackIPList',
		component: () => import(/* webpackChunkName: "IpList", */ '@/views/ips/black'),
		meta: {}
	},
	{
		path: '/agreeCountry',
		name: 'AgreeCountry',
		component: () => import(/* webpackChunkName: "IpList", */ '@/views/country/white'),
		meta: {}
	},
	{
		path: '/updateToken',
		name: 'UpdateToken',
		component: () => import(/* webpackChunkName: "IpList", */ '@/views/token/update'),
		meta: {}
	}
];
